<template>
    <div class="xtxx">
        <div class="content">

            <div class="form-container">
                <!-- 抬头类型 -->
                <div class="form-item">
                    <span class="form-label">抬头类型</span>
                    <div class="radio-group">
                        <label class="radio-label" :class="{ active: titleType === 'personal' }" @click="titleType = 'personal'">
                            <span class="radio-circle"></span>
                            <span>个人</span>
                        </label>
                        <label class="radio-label" :class="{ active: titleType === 'company' }" @click="titleType = 'company'">
                            <span class="radio-circle"></span>
                            <span>企业单位</span>
                        </label>
                        <label class="radio-label" :class="{ active: titleType === 'nonCompany' }" @click="titleType = 'nonCompany'">
                            <span class="radio-circle"></span>
                            <span>非企业单位</span>
                        </label>
                    </div>
                </div>

                <!-- 发票抬头 -->
                <div class="form-item required">
                    <span class="form-label">发票抬头 <span class="required-mark">*</span></span>
                    <div class="form-input-group">
                        <input type="text" class="form-input" v-model="invoiceTitle" placeholder="请输入抬头名称">
                        <button class="btn-more-add" @click="showTitlePopup = true">更多/添加</button>
                    </div>
                </div>

                <!-- 税号：个人=身份证号，企业/非企业单位=税号；非自然人必须传税号，均必填 -->
                <div class="form-item required">
                    <span class="form-label">
                        {{ titleType === 'personal' ? '身份证号' : '税号' }}
                        <span class="required-mark">*</span>
                    </span>
                    <input
                        type="text"
                        class="form-input"
                        v-model="taxNo"
                        :placeholder="titleType === 'personal' ? '请填写身份证号' : '请填写税号'"
                    >
                </div>

                <!-- 发票格式 -->
                <div class="form-item">
                    <span class="form-label">发票格式</span>
                    <span class="format-value">PDF</span>
                </div>

                <!-- 开票金额 -->
                <div class="form-item">
                    <span class="form-label">开票金额</span>
                    <span class="amount-value">¥{{ amount }}</span>
                </div>

                <!-- 公司地址 -->
                <div class="form-item">
                    <span class="form-label">公司地址</span>
                    <input type="text" class="form-input" v-model="companyAddress" placeholder="填写公司地址">
                </div>

                <!-- 公司电话 -->
                <div class="form-item">
                    <span class="form-label">公司电话</span>
                    <input type="text" class="form-input" v-model="companyPhone" placeholder="填写公司电话">
                </div>

                <!-- 公司开户行 -->
                <div class="form-item">
                    <span class="form-label">公司开户行</span>
                    <input type="text" class="form-input" v-model="companyBank" placeholder="填写公司开户行">
                </div>

                <!-- 开户行账号 -->
                <div class="form-item">
                    <span class="form-label">开户行账号</span>
                    <input type="text" class="form-input" v-model="bankAccount" placeholder="填写开户行账号">
                </div>

                <!-- 备注 -->
                <div class="form-item">
                    <span class="form-label">备注</span>
                    <textarea class="form-textarea" v-model="remark" placeholder="请输入备注信息（选填）"></textarea>
                </div>
            </div>

            <!-- 提交按钮 -->
            <div class="submit-section">
                <button
                    class="btn-submit"
                    :class="{ active: isFormValid }"
                    :disabled="!isFormValid"
                    @click="onSubmit"
                >提交</button>
            </div>
        </div>

        <!-- 发票抬头选择弹窗 -->
        <van-popup v-model="showTitlePopup" position="bottom" round>
            <div class="title-popup">
                <div class="title-popup-header">
                    <span class="title-popup-title">选择发票抬头</span>
                    <button class="title-popup-close" @click="showTitlePopup = false">×</button>
                </div>
                <div class="title-popup-content">
                    <div
                        class="title-item"
                        v-for="(title, index) in savedTitles"
                        :key="index"
                    >
                        <div class="title-info" @click="selectTitle(title)">
                            <div class="title-name">{{ title.titleName }}</div>
                            <div class="title-taxno" v-if="title.taxNo">{{ title.taxNo }}</div>
                        </div>
                        <div class="title-actions">
                            <span class="action-btn action-default" v-if="title.isDefault !== 1" @click.stop="setDefaultTitle(title)">设为默认</span>
                            <span class="action-btn action-default active" v-else>默认</span>
                            <span class="action-btn action-edit" @click.stop="editTitle(title)">编辑</span>
                            <span class="action-btn action-delete" @click.stop="deleteTitle(title)">删除</span>
                        </div>
                    </div>
                    <div class="title-empty" v-if="savedTitles.length === 0">暂无保存的抬头，请添加</div>
                </div>
                <div class="title-popup-footer">
                    <button class="btn-add-title" @click="showTitlePopup = false; editingTitleId = null; addTitleName = ''; addTitleType = 'company'; addTitleTaxNo = ''; addTitleAddress = ''; addTitlePhone = ''; addTitleBank = ''; addTitleBankAccount = ''; showAddForm = true">添加发票抬头</button>
                </div>
            </div>
        </van-popup>

        <!-- 添加/编辑抬头弹窗 -->
        <van-popup v-model="showAddForm" position="bottom" round>
            <div class="add-form-popup">
                <div class="title-popup-header">
                    <span class="title-popup-title">{{ editingTitleId ? '编辑发票抬头' : '添加发票抬头' }}</span>
                    <button class="title-popup-close" @click="showAddForm = false">×</button>
                </div>
                <div class="add-form-content">
                    <div class="add-form-item">
                        <span class="form-label">名称 <span class="required-mark">*</span></span>
                        <input type="text" class="form-input" v-model="addTitleName" placeholder="请输入名称">
                    </div>
                    <div class="add-form-item">
                        <span class="form-label">类型</span>
                        <div class="radio-group">
                            <label class="radio-label" :class="{ active: addTitleType === 'personal' }" @click="addTitleType = 'personal'">
                                <span class="radio-circle"></span>
                                <span>个人</span>
                            </label>
                            <label class="radio-label" :class="{ active: addTitleType === 'company' }" @click="addTitleType = 'company'">
                                <span class="radio-circle"></span>
                                <span>企业单位</span>
                            </label>
                            <label class="radio-label" :class="{ active: addTitleType === 'nonCompany' }" @click="addTitleType = 'nonCompany'">
                                <span class="radio-circle"></span>
                                <span>非企业单位</span>
                            </label>
                        </div>
                    </div>
                    <div class="add-form-item" v-if="addTitleType !== 'personal'">
                        <span class="form-label">税号 <span class="required-mark">*</span></span>
                        <input type="text" class="form-input" v-model="addTitleTaxNo" placeholder="请输入税号">
                    </div>
                    <div class="add-form-item" v-else>
                        <span class="form-label">身份证号 <span class="required-mark">*</span></span>
                        <input type="text" class="form-input" v-model="addTitleTaxNo" placeholder="请输入身份证号">
                    </div>
                    <div class="add-form-item" v-if="addTitleType !== 'personal'">
                        <span class="form-label">公司地址</span>
                        <input type="text" class="form-input" v-model="addTitleAddress" placeholder="填写公司地址">
                    </div>
                    <div class="add-form-item" v-if="addTitleType !== 'personal'">
                        <span class="form-label">公司电话</span>
                        <input type="text" class="form-input" v-model="addTitlePhone" placeholder="填写公司电话">
                    </div>
                    <div class="add-form-item" v-if="addTitleType !== 'personal'">
                        <span class="form-label">开户行</span>
                        <input type="text" class="form-input" v-model="addTitleBank" placeholder="填写开户行">
                    </div>
                    <div class="add-form-item" v-if="addTitleType !== 'personal'">
                        <span class="form-label">银行账号</span>
                        <input type="text" class="form-input" v-model="addTitleBankAccount" placeholder="填写银行账号">
                    </div>
                </div>
                <div class="add-form-footer">
                    <button class="btn-save-title" @click="saveNewTitle">保存</button>
                </div>
            </div>
        </van-popup>

        <!-- 邮箱弹窗 -->
        <van-popup v-model="showEmailPopup" round :style="{ width: '90%', maxWidth: '360px' }">
            <div class="email-popup">
                <div class="email-popup-header">
                    <h3 class="email-popup-title">请输入接收发票的电子邮箱地址</h3>
                </div>
                <div class="email-popup-body">
                    <input type="email" class="email-input" v-model="email" placeholder="请输入邮箱地址" maxlength="100">
                    <span class="email-error" v-if="emailError">{{ emailError }}</span>
                </div>
                <div class="email-popup-footer">
                    <button class="email-btn email-btn-cancel" @click="showEmailPopup = false">取消</button>
                    <button class="email-btn email-btn-confirm" @click="confirmEmail">确认</button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    computed: {
        ...mapState(['userInfo', 'address']),
        isFormValid() {
            if (!this.invoiceTitle) return false;
            // 个人=身份证号、企业单位/非企业单位=税号，均必填（客户要求非自然人必须传税号）
            if (!this.taxNo) return false;
            return true;
        }
    },
    data() {
        return {
            titleType: 'personal',
            invoiceTitle: '',
            taxNo: '',
            invoiceFormat: 'pdf',
            amount: '0',
            villageId: '',
            companyAddress: '',
            companyPhone: '',
            companyBank: '',
            bankAccount: '',
            remark: '',
            showEmailPopup: false,
            email: '',
            emailError: '',
            showTitlePopup: false,
            savedTitles: [],
            showAddForm: false,
            editingTitleId: null,
            addTitleName: '',
            addTitleType: 'company',
            addTitleTaxNo: '',
            addTitleAddress: '',
            addTitlePhone: '',
            addTitleBank: '',
            addTitleBankAccount: '',
            // 销方信息（从后端动态获取）
            sellerInfo: null,
            // 小区是否启用开票（从后端动态获取）
            invoiceEnabled: null,
            // 备注相关
            villageName: '',
            ownerName: '',
            serviceTime: '',
            typeName: '',
        }
    },
    mounted() {
        this.amount = this.$route.query.amount || '0';
        this.villageId = this.$route.query.villageId || '';
        this.villageName = this.$route.query.villageName || '';
        this.ownerName = this.$route.query.ownerName || '';
        this.serviceTime = this.$route.query.time || '';
        this.typeName = this.$route.query.typeName || '';
        this.loadTitles();
        // 始终加载费用项数据，确保房主姓名等字段能兜底获取
        if (this.$route.query.id) {
            this.loadFeeItemData();
        } else {
            this.loadSellerInfo();
        }
    },
    methods: {
        loadFeeItemData() {
            var that = this;
            var feeId = this.$route.query.id;
            var feeType = this.$route.query.type || '';
            that.$axios.get('/api/v1/wygl/propertyPayment/viewListById?id=' + feeId).then(function(res) {
                if (res && Array.isArray(res)) {
                    var item = null;
                    if (feeType) {
                        item = res.find(function(i) { return i.type === feeType; });
                    }
                    if (!item && res.length > 0) {
                        item = res[0];
                    }
                    if (item) {
                        if (!that.villageId) that.villageId = item.villageId || '';
                        if (!that.villageName) that.villageName = item.villageName || '';
                        if (!that.ownerName) that.ownerName = item.owoner || '';
                        if (!that.serviceTime) that.serviceTime = item.time || '';
                        if (!that.typeName) that.typeName = item.typeName || '';
                    }
                }
                that.loadSellerInfo();
            });
        },
        loadSellerInfo() {
            // 同步校验小区是否启用开票，未启用则直接返回上一页（与 sellerInfo 并行）
            this.checkInvoiceEnabled(true);
            if (!this.villageId) {
                console.log('villageId为空，无法获取卖家信息');
                return;
            }
            console.log('请求sellerInfo, villageId:', this.villageId);
            this.$axios.get('/api/v1/wygl/propertyPayment/getSellerInfo', {
                params: { villageId: this.villageId }
            }).then(res => {
                console.log('sellerInfo返回数据:', JSON.stringify(res));
                if (res) {
                    this.sellerInfo = res;
                }
            }).catch(err => {
                console.log('获取卖家信息失败', err);
            });
        },
        // 校验小区是否启用开票。earlyExit=true 时未启用则自动返回上一页
        checkInvoiceEnabled(earlyExit) {
            if (!this.villageId) {
                this.invoiceEnabled = false;
                if (earlyExit) this.redirectBackWhenDisabled();
                return Promise.resolve(false);
            }
            return this.$axios.get('/api/v1/wygl/propertyPayment/invoiceEnabled', {
                params: { communityId: this.villageId }
            }).then(res => {
                this.invoiceEnabled = !!res;
                if (!this.invoiceEnabled && earlyExit) {
                    this.redirectBackWhenDisabled();
                }
                return this.invoiceEnabled;
            }).catch(err => {
                console.log('校验开票开关失败', err);
                this.invoiceEnabled = false;
                if (earlyExit) this.redirectBackWhenDisabled();
                return false;
            });
        },
        redirectBackWhenDisabled() {
            this.$toast('该小区暂未开通开票功能');
            var that = this;
            setTimeout(function() {
                that.$router.go(-1);
            }, 1500);
        },
        loadTitles() {
            var that = this;
            that.$axios.get('/api/v1/wygl/propertyPayment/invoiceTitle/list').then(function(res) {
                if (res && Array.isArray(res)) {
                    that.savedTitles = res;
                    var defaultTitle = res.find(function(t) { return t.isDefault === 1; });
                    if (defaultTitle && !that.invoiceTitle) {
                        that.selectTitle(defaultTitle);
                    }
                }
            }).catch(function() {
                that.savedTitles = [];
            });
        },
        selectTitle(title) {
            this.invoiceTitle = title.titleName;
            this.taxNo = title.taxNo || '';
            this.titleType = title.titleType || 'personal';
            this.companyAddress = title.companyAddress || '';
            this.companyPhone = title.companyPhone || '';
            this.companyBank = title.companyBank || '';
            this.bankAccount = title.bankAccount || '';
            this.showTitlePopup = false;
        },
        editTitle(title) {
            this.editingTitleId = title.id;
            this.addTitleName = title.titleName;
            this.addTitleType = title.titleType || 'company';
            this.addTitleTaxNo = title.taxNo || '';
            this.addTitleAddress = title.companyAddress || '';
            this.addTitlePhone = title.companyPhone || '';
            this.addTitleBank = title.companyBank || '';
            this.addTitleBankAccount = title.bankAccount || '';
            this.showAddForm = true;
        },
        deleteTitle(title) {
            var that = this;
            that.$dialog.confirm({
                title: '提示',
                message: '确定删除该发票抬头吗？'
            }).then(function() {
                that.$axios.delete('/api/v1/wygl/propertyPayment/invoiceTitle/delete/' + title.id).then(function(res) {
                    if (res !== false) {
                        that.$toast.success('删除成功');
                        that.loadTitles();
                    }
                });
            }).catch(function() {
                // 取消删除
            });
        },
        setDefaultTitle(title) {
            var that = this;
            that.$axios.post('/api/v1/wygl/propertyPayment/invoiceTitle/setDefault/' + title.id).then(function(res) {
                if (res !== false) {
                    that.$toast.success('设置成功');
                    that.loadTitles();
                }
            });
        },
        saveNewTitle() {
            if (!this.addTitleName) {
                this.$toast('请输入名称');
                return;
            }
            if (this.addTitleType !== 'personal' && !this.addTitleTaxNo) {
                this.$toast('请输入税号');
                return;
            }
            if (this.addTitleType === 'personal' && !this.addTitleTaxNo) {
                this.$toast('请输入身份证号');
                return;
            }
            var requestData = {
                id: this.editingTitleId,
                titleType: this.addTitleType,
                titleName: this.addTitleName,
                taxNo: this.addTitleTaxNo,
                companyAddress: this.addTitleAddress,
                companyPhone: this.addTitlePhone,
                companyBank: this.addTitleBank,
                bankAccount: this.addTitleBankAccount
            };
            var that = this;
            that.$axios.post('/api/v1/wygl/propertyPayment/invoiceTitle/save', requestData).then(function(res) {
                if (res !== false) {
                    that.$toast.success(that.editingTitleId ? '修改成功' : '添加成功');
                    that.addTitleName = '';
                    that.addTitleTaxNo = '';
                    that.addTitleAddress = '';
                    that.addTitlePhone = '';
                    that.addTitleBank = '';
                    that.addTitleBankAccount = '';
                    that.editingTitleId = null;
                    that.showAddForm = false;
                    that.loadTitles();
                    that.showTitlePopup = true;
                }
            });
        },
        selectFromWechat() {
            var that = this;
            if (typeof wx === 'undefined') {
                that.$toast('请在微信中打开使用此功能');
                return;
            }
            var axios = require('axios');
            axios.get('/api/wechat/wxConfig', {
                params: { url: window.location.href.split('#')[0] }
            }).then(function(res) {
                var data = res.data.data;
                wx.config({
                    debug: false,
                    appId: data.appId,
                    timestamp: data.timestamp,
                    nonceStr: data.nonceStr,
                    signature: data.signature,
                    jsApiList: ['chooseInvoiceTitle']
                });
                wx.ready(function() {
                    wx.chooseInvoiceTitle({
                        success: function(res) {
                            var type = res.type === '1' ? 'company' : 'personal';
                            that.invoiceTitle = res.title;
                            that.taxNo = res.taxNumber || '';
                            that.titleType = type;
                            that.companyAddress = res.companyAddress || '';
                            that.companyPhone = res.telephone || '';
                            that.companyBank = res.bankName || '';
                            that.bankAccount = res.bankAccount || '';
                            // 保存到后端
                            that.$axios.post('/api/v1/wygl/propertyPayment/invoiceTitle/save', {
                                titleType: type,
                                titleName: res.title,
                                taxNo: res.taxNumber || '',
                                companyAddress: res.companyAddress || '',
                                companyPhone: res.telephone || '',
                                companyBank: res.bankName || '',
                                bankAccount: res.bankAccount || ''
                            }).then(function() {
                                that.loadTitles();
                            });
                            that.showTitlePopup = false;
                            that.$toast('已从微信选择发票抬头');
                        },
                        fail: function(err) {
                            if (err.errMsg && err.errMsg.indexOf('cancel') !== -1) {
                                that.$toast('已取消选择');
                            } else {
                                that.$toast('选择发票抬头失败，请重试');
                            }
                        }
                    });
                });
                wx.error(function() {
                    that.$toast('微信授权失败，请重试');
                });
            }).catch(function() {
                that.$toast('获取微信配置失败');
            });
        },
        onSubmit() {
            this.email = '';
            this.emailError = '';
            this.showEmailPopup = true;
        },
        confirmEmail() {
            if (this.email) {
                var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(this.email)) {
                    this.emailError = '请输入正确的邮箱格式';
                    return;
                }
            }
            // 提交时再次校验小区是否启用开票（兜底，避免配置变更或绕过入口）
            var that = this;
            this.checkInvoiceEnabled(false).then(function(enabled) {
                if (!enabled) {
                    that.$toast('该小区暂未开通开票功能');
                    return;
                }
                that.doSubmitInvoice();
            });
        },
        doSubmitInvoice() {
            // 校验卖家信息
            if (!this.sellerInfo) {
                this.$toast('该小区暂未配置发票卖家信息，无法开票');
                return;
            }
            var that = this;
            var amount = parseFloat(this.amount) || 0;
            console.log('sellerInfo完整数据:', JSON.stringify(this.sellerInfo));
            console.log('sellerInfo.slv:', this.sellerInfo.slv);
            console.log('ownerName:', this.ownerName, 'villageName:', this.villageName, 'serviceTime:', this.serviceTime);
            var slv = parseFloat(this.sellerInfo.slv) || 0;
            // 税额 = 含税金额 * 税率 / (1 + 税率)，先算税额再反推不含税金额，避免二次舍入误差
            var hjse = Math.round(amount * slv / (1 + slv) * 100) / 100;
            var hjje = Math.round((amount - hjse) * 100) / 100;
            var now = new Date();
            var djrq = now.getFullYear() + '-' +
                String(now.getMonth() + 1).padStart(2, '0') + '-' +
                String(now.getDate()).padStart(2, '0') + ' ' +
                String(now.getHours()).padStart(2, '0') + ':' +
                String(now.getMinutes()).padStart(2, '0') + ':' +
                String(now.getSeconds()).padStart(2, '0');
            var xsdjbh = 'FP' + Date.now() + Math.floor(Math.random() * 1000);
            var typeName = this.typeName || '物业服务费';
            // 构造备注内容：小区名称+房屋地址 业主姓名 服务期限
            var bzParts = [];
            var houseName = sessionStorage.getItem('houseName') || this.villageName || '';
            if (houseName) bzParts.push(houseName);
            if (this.ownerName) bzParts.push(this.ownerName);
            if (this.serviceTime) {
                var zhiIdx = this.serviceTime.indexOf('至');
                if (zhiIdx > -1) {
                    var startDate = this.serviceTime.substring(0, zhiIdx).slice(0, 10);
                    var endDate = this.serviceTime.substring(zhiIdx + 1).slice(0, 10);
                    bzParts.push('服务期限：' + startDate + '至' + endDate);
                }
            }
            if (this.remark) bzParts.push(this.remark);
            bzParts.push('（ZFKP）');
            var requestData = {
                xsdjbh: xsdjbh,
                // 销方信息（从后端动态获取）
                xfmc: this.sellerInfo.companyName,
                xfsh: this.sellerInfo.taxNumber,
                xsfdz: this.sellerInfo.companyAddress || '',
                xsflxdh: this.sellerInfo.contactPhone || '',
                xsfkhh: this.sellerInfo.bankName || '',
                xsfyhzh: this.sellerInfo.bankAccount || '',
                // 关联字段（用于反向查询发票状态）
                def01: this.$route.query.id || '',    // 缴费记录ID
                def02: this.$route.query.type || '',   // 费用类型
                // 购方信息（titleType 供后端推导 gmfZrrbs：个人=Y，企业/非企业=N，且非自然人必须传税号）
                isUpdateBuyer: 'N',
                titleType: this.titleType,
                gfmc: this.invoiceTitle,
                gfsh: this.taxNo || '',
                gfyx: this.email || '',
                gmfdz: this.companyAddress || '',
                gmflxdh: this.companyPhone || '',
                gmfkhh: this.companyBank || '',
                gmfyhzh: this.bankAccount || '',
                // 金额（根据税率计算）
                qdbz: '0',
                zdkpbj: 'Y',
                jshj: amount,
                hjje: hjje,
                hjse: hjse,
                djrq: djrq,
                bz: bzParts.join(' '),
                kplx: '0',
                // 发票格式
                fpzl: '02',
                // 商品明细
                listOrder: [{
                    spmc: typeName,
                    je: amount,
                    fphxz: '0',
                    hsjbz: '1',
                    slv: slv,
                    se: hjse,
                    flbm: '',
                    yhbz: '0'
                }]
            };
            var that = this;
            that.showEmailPopup = false;
            // request.js 会自动弹 loading toast 和清除
            that.$axios.post('/api/v1/wygl/propertyPayment/applyInvoice', requestData).then(function(res) {
                that.$toast.clear();
                // request.js 拦截器: 成功返回 res.data，失败返回 false 并弹Dialog
                if (res && res.returnCode === '1000') {
                    that.$toast.success('提交成功，发票开具中！');
                    setTimeout(function() {
                        that.$router.go(-1);
                    }, 1500);
                } else if (res === false) {
                    // 拦截器已弹了错误Dialog，这里不需要再处理
                } else {
                    that.$dialog.alert({ title: '提示', message: (res && res.returnMsg) || '提交失败，请重试' });
                }
            }).catch(function(err) {
                that.$toast.clear();
                that.$toast.fail('网络异常，请重试');
                console.log('发票接口请求失败:', err);
            });
        }
    }
}
</script>

<style lang="less" scoped>
    .xtxx{
        height: calc(100% - 50px);
        width: 100%;
        display: flex;
        background-color: #fff;
        flex-direction: column;
        align-items: center;
        overflow-y: auto;
    }
    .content{
        height: 100%;
        width: 92%;
        margin: 0 4% 0 4%;
    }
    .form-container{
        .form-item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 0;
            border-bottom: 1px solid #eee;
            &.required{
                background-color: #fff5f5;
                margin: 0 -15px;
                padding: 15px;
            }
            .form-label{
                font-size: 14px;
                color: #333;
                flex-shrink: 0;
                width: 90px;
                .required-mark{
                    color: #f44336;
                }
            }
            .form-input{
                flex: 1;
                text-align: right;
                border: none;
                outline: none;
                font-size: 14px;
                color: #333;
                background: transparent;
            }
            .form-input-group{
                display: flex;
                align-items: center;
                flex: 1;
                .form-input{
                    flex: 1;
                    text-align: left;
                }
                .btn-more-add{
                    padding: 0 10px;
                    height: 32px;
                    border: none;
                    background-color: #f0f0f0;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #666;
                    margin-left: 8px;
                }
            }
            .radio-group{
                display: flex;
                gap: 15px;
                flex-wrap: wrap;
                .radio-label{
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #666;
                    .radio-circle{
                        width: 18px;
                        height: 18px;
                        border: 2px solid #ddd;
                        border-radius: 50%;
                        margin-right: 6px;
                        position: relative;
                        transition: all 0.2s;
                    }
                    &.active .radio-circle{
                        border-color: #00b5ff;
                        background-color: #00b5ff;
                        &::after{
                            content: '';
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 8px;
                            height: 8px;
                            background-color: #ffffff;
                            border-radius: 50%;
                        }
                    }
                }
            }
            .amount-value{
                font-size: 18px;
                font-weight: 600;
                color: #333;
            }
            .format-value{
                font-size: 14px;
                color: #333;
            }
            .form-textarea{
                flex: 1;
                text-align: right;
                border: none;
                outline: none;
                font-size: 14px;
                color: #333;
                resize: none;
                min-height: 60px;
                padding: 8px 0;
                background: transparent;
            }
        }
    }
    .submit-section{
        padding: 20px 0;
        .btn-submit{
            width: 100%;
            height: 44px;
            background-color: #ddd;
            color: #999;
            border: none;
            border-radius: 22px;
            font-size: 16px;
            font-weight: 500;
            &.active{
                background-color: #00b5ff;
                color: #ffffff;
            }
        }
    }
    /* 抬头选择弹窗 */
    .title-popup{
        .title-popup-header{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px;
            .title-popup-title{
                font-size: 16px;
                font-weight: 600;
                color: #333;
            }
            .title-popup-close{
                width: 30px;
                height: 30px;
                border: none;
                background: transparent;
                font-size: 24px;
                color: #999;
            }
        }
        .title-popup-content{
            max-height: 50vh;
            overflow-y: auto;
            padding: 0 15px;
            .title-item{
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 16px;
                border: 1px solid #f0f0f0;
                border-radius: 8px;
                margin-bottom: 10px;
                &:active{
                    background-color: #f9f9f9;
                }
                .title-info{
                    flex: 1;
                    .title-name{
                        font-size: 15px;
                        font-weight: 500;
                        color: #333;
                    }
                    .title-taxno{
                        font-size: 13px;
                        color: #999;
                        margin-top: 4px;
                    }
                }
                .title-actions{
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-left: 10px;
                    flex-shrink: 0;
                    .action-btn{
                        font-size: 12px;
                        padding: 4px 8px;
                        border-radius: 4px;
                        white-space: nowrap;
                    }
                    .action-default{
                        color: #999;
                        background-color: #f5f5f5;
                        &.active{
                            color: #00b5ff;
                            background-color: #e6f7ff;
                        }
                    }
                    .action-edit{
                        color: #00b5ff;
                        background-color: #e6f7ff;
                    }
                    .action-delete{
                        color: #ff4444;
                        background-color: #fff0f0;
                    }
                }
            }
            .title-empty{
                text-align: center;
                color: #999;
                padding: 40px 0;
                font-size: 14px;
            }
        }
        .title-popup-footer{
            padding: 15px;
            padding-bottom: 30px;
            display: flex;
            gap: 10px;
            .btn-add-title{
                flex: 1;
                padding: 14px;
                background-color: #00b5ff;
                color: #ffffff;
                border: none;
                border-radius: 8px;
                font-size: 14px;
                font-weight: 600;
            }
            .btn-wechat-title{
                flex: 1;
                padding: 14px;
                background-color: #07c160;
                color: #ffffff;
                border: none;
                border-radius: 8px;
                font-size: 14px;
                font-weight: 600;
            }
        }
    }
    /* 添加抬头弹窗 */
    .add-form-popup{
        .add-form-content{
            padding: 15px;
            .add-form-item{
                margin-bottom: 15px;
                .form-label{
                    font-size: 14px;
                    color: #666;
                    margin-bottom: 8px;
                    display: block;
                    .required-mark{
                        color: #f44336;
                    }
                }
                .form-input{
                    width: 100%;
                    padding: 12px;
                    border: 1px solid #ddd;
                    border-radius: 8px;
                    font-size: 14px;
                    box-sizing: border-box;
                    outline: none;
                }
                .radio-group{
                    display: flex;
                    gap: 20px;
                    margin-top: 8px;
                    .radio-label{
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        color: #666;
                        .radio-circle{
                            width: 18px;
                            height: 18px;
                            border: 2px solid #ddd;
                            border-radius: 50%;
                            margin-right: 6px;
                            position: relative;
                        }
                        &.active .radio-circle{
                            border-color: #00b5ff;
                            background-color: #00b5ff;
                            &::after{
                                content: '';
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                width: 8px;
                                height: 8px;
                                background-color: #ffffff;
                                border-radius: 50%;
                            }
                        }
                    }
                }
            }
        }
        .add-form-footer{
            padding: 0 15px 30px;
            .btn-save-title{
                width: 100%;
                padding: 14px;
                background-color: #00b5ff;
                color: #ffffff;
                border: none;
                border-radius: 8px;
                font-size: 15px;
                font-weight: 600;
            }
        }
    }
    /* 邮箱弹窗 */
    .email-popup{
        .email-popup-header{
            padding: 24px 20px 16px;
            text-align: center;
            .email-popup-title{
                font-size: 17px;
                font-weight: 600;
                color: #333;
                margin: 0;
                line-height: 1.5;
            }
        }
        .email-popup-body{
            padding: 0 20px;
            .email-input{
                width: 100%;
                height: 48px;
                padding: 0 16px;
                border: 1px solid #e0e0e0;
                border-radius: 10px;
                font-size: 15px;
                color: #333;
                background-color: #fafafa;
                box-sizing: border-box;
                outline: none;
                &:focus{
                    border-color: #00b5ff;
                    background-color: #ffffff;
                }
            }
            .email-error{
                display: block;
                height: 20px;
                font-size: 13px;
                color: #ff4444;
                margin-top: 8px;
            }
        }
        .email-popup-footer{
            display: flex;
            gap: 12px;
            padding: 20px;
            .email-btn{
                flex: 1;
                height: 44px;
                border: none;
                border-radius: 10px;
                font-size: 16px;
                font-weight: 500;
            }
            .email-btn-cancel{
                background-color: #f5f5f5;
                color: #666;
            }
            .email-btn-confirm{
                background-color: #00b5ff;
                color: #ffffff;
            }
        }
    }
    ::-webkit-scrollbar{
        display: none;
    }
</style>
